import {
  EMPTY_NORMALIZATION_RULE,
  EMPTY_RULE_SET,
} from "@/react/features/support-tools/dialplans/constants";
import lodash from "lodash";
import React from "react";

const getUpdatedDialplan = (dialplan, path, value) => {
  const newDialplan = lodash.cloneDeep(dialplan);
  lodash.set(newDialplan, path, value);
  return newDialplan;
};

export const useDialPlanChangeControls = ({ setDialplan }) => {
  const handleAddRuleSet = () => {
    setDialplan((dialplan) => ({
      ...dialplan,
      ruleSet: [...dialplan.ruleSet, { ...EMPTY_RULE_SET }],
    }));
  };

  const onDeleteRuleSet = (e, index) => {
    e.stopPropagation();
    setDialplan((dialplan) => ({
      ...dialplan,
      ruleSet: dialplan.ruleSet.filter((_, i) => i !== index),
    }));
  };

  const onChangeRegExpr = (index) => (value, normalizationRuleIndex) => {
    const path = `ruleSet[${index}].normalizationRule[${normalizationRuleIndex}].regExpr`;
    setDialplan((dialplan) => getUpdatedDialplan(dialplan, path, value));
  };

  const onChangeReplace = (index) => (value, normalizationRuleIndex) => {
    const path = `ruleSet[${index}].normalizationRule[${normalizationRuleIndex}].replace`;
    setDialplan((dialplan) => getUpdatedDialplan(dialplan, path, value));
  };

  const onChangeDescription = (index) => (value) => {
    const path = `ruleSet[${index}].description`;
    setDialplan((dialplan) => getUpdatedDialplan(dialplan, path, value));
  };

  const onAddNormalizationRule = (index) => {
    const path = `ruleSet[${index}].normalizationRule`;
    setDialplan((dialplan) => {
      const normalizationRules = lodash.cloneDeep(lodash.get(dialplan, path));
      normalizationRules.push({ ...EMPTY_NORMALIZATION_RULE });
      return getUpdatedDialplan(dialplan, path, normalizationRules);
    });
  };

  const onDeleteNormalizationRule = (index) => (normalizationRuleIndex) => {
    const path = `ruleSet[${index}].normalizationRule`;
    setDialplan((dialplan) => {
      const normalizationRules = lodash.cloneDeep(lodash.get(dialplan, path));
      return getUpdatedDialplan(
        dialplan,
        path,
        normalizationRules.filter((_, i) => i !== normalizationRuleIndex)
      );
    });
  };

  const onRuleSetTypeChanged = (opt, index) => {
    const path = `ruleSet[${index}].ruleSetType`;
    setDialplan((dialplan) => getUpdatedDialplan(dialplan, path, opt.value));
  };

  return React.useMemo(
    () => ({
      handleAddRuleSet,
      onDeleteRuleSet,
      onChangeRegExpr,
      onChangeReplace,
      onChangeDescription,
      onAddNormalizationRule,
      onDeleteNormalizationRule,
      onRuleSetTypeChanged,
    }),
    [setDialplan]
  );
};
